import { API_URL_NEWS } from "@constants/env";
import apiInstance from "@services/Shared/instanceAxios";
import TCreateEditNews from "types/News/createEditNews";

const createNews = (news: TCreateEditNews) =>
  apiInstance({
    url: API_URL_NEWS,
    method: "post",
    data: news,
  });

export default createNews;
